module.exports = __webpack_public_path__ + "img/energy-providers.c4cacba.webp";